export function booleanAttribute(value: boolean | string): boolean {
  return typeof value === 'string' ? value === '' : value;
}
